<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		xmlns="http://www.w3.org/2000/svg"
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M5.45455 9.64495C5.00268 9.64495 4.63636 9.99067 4.63636 10.4171V19.6835C4.63636 20.1099 5.00268 20.4557 5.45455 20.4557H18.5455C18.9973 20.4557 19.3636 20.1099 19.3636 19.6835V10.4171C19.3636 9.99067 18.9973 9.64495 18.5455 9.64495H16.5C16.0481 9.64495 15.6818 9.29922 15.6818 8.87275C15.6818 8.44628 16.0481 8.10056 16.5 8.10056H18.5455C19.901 8.10056 21 9.13772 21 10.4171V19.6835C21 20.9629 19.901 22.0001 18.5455 22.0001H5.45455C4.09893 22.0001 3 20.9629 3 19.6835V10.4171C3 9.13772 4.09893 8.10056 5.45455 8.10056H7.5C7.95187 8.10056 8.31818 8.44628 8.31818 8.87275C8.31818 9.29922 7.95187 9.64495 7.5 9.64495H5.45455ZM11.182 4.45002L8.83908 6.66128C8.55151 6.93267 8.08527 6.93267 7.7977 6.66128C7.51014 6.38987 7.51014 5.94984 7.7977 5.67843L11.4795 2.20356C11.6176 2.07322 11.8049 2 12.0002 2C12.1955 2 12.3828 2.07322 12.5209 2.20356L16.2027 5.67843C16.4902 5.94984 16.4902 6.38987 16.2027 6.66128C15.9151 6.93267 15.4489 6.93267 15.1613 6.66128L12.8184 4.45002V15.0501C12.8184 15.4766 12.4521 15.8223 12.0002 15.8223C11.5483 15.8223 11.182 15.4766 11.182 15.0501V4.45002Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
